<template lang="html">
  <div class="jump-banner" v-if="newPosters && newPosters.length > 0">
    <slot></slot>
    <swipe :auto="5000" :show-indicators="newPosters && newPosters.length > 1">
      <swipe-item v-for="(item, index) in newPosters" :key="index">
        <a :href="item.link" @click="clickImage(index, item)">
          <img v-lazy="$$viewImage(item.img)" />
        </a>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'mint-ui'

export default {
  // PAGE_ID: '288987',
  props: {
    posters: {
      type: Array,
      default() {
        return []
      }
    },
    citycode: Number | String
  },
  methods: {
    clickImage(index, item) {
      const uid = this.$$cookie('uid') || ''
      this.trackClick(
        200024,
        {
          surl: item.link || '',
          infotitle: item.title || '',
          citycode: this.citycode,
          fuid: uid
        },
        `surl: ${item.link}, infotitle: ${item.title}, citycode: ${this.citycode}, fuid: ${uid}`,
        121011908,
        `${index + 1}`
      )
    }
  },
  computed: {
    newPosters() {
      return this.posters.filter(ele => ele.link !== '' && ele.image !== '')
    }
  },
  components: {
    Swipe,
    SwipeItem
  }
}
</script>

<style lang="scss" scope>
@import '../../assets/css/mixin';
.jump-banner {
  height: rem(180px);
  position: relative;
  padding: rem(30px);
  padding-top: rem(20px);
  padding-bottom: rem(10px);
  a {
    display: block;
    height: rem(148px);
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
// .mint-swipe-indicator.is-active
// 评论成功页
.comment-poster {
  height: rem(200px);
  img {
    height: rem(200px);
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
.jump-banner {
  .mint-swipe-indicators {
    bottom: 0;
  }
  .mint-swipe-indicator {
    width: rem(12px);
    height: rem(4px);
    opacity: 0.4;
    background: #ffffff;
    border-radius: rem(5px);
    margin: 0 rem(2px);
  }
  .mint-swipe-indicator.is-active {
    opacity: 1;
  }
}
</style>
